import { METERED_VARIABLES, getLatestMeteredVariable, } from "./getMeteredVariables.js";
import { getContractInitialSku } from "./selectors/meta.js";
import Logger from "@cappelendamm/logger";
export const getNextSeriesBook = (subscriptionPlan, usage, contract, campaignBooks, seriesProducts) => {
    if (!seriesProducts)
        return null;
    const lastReceivedBook = getLatestMeteredVariable({
        subscriptionPlan,
        identifier: METERED_VARIABLES.PROGRESSION_INDEX,
        usage,
    })?.idempotencyKey;
    const indexOfLastReceivedBookInSeries = seriesProducts.findIndex(({ sku }) => sku === lastReceivedBook);
    // If the last received book is not found in the series, log a warning and return null
    if (lastReceivedBook && indexOfLastReceivedBookInSeries === -1) {
        Logger.warn(`Latest book with sku ${lastReceivedBook} not found in series definition for contract ${contract.id} with subscription plan ${contract.item.sku}.`);
        return null;
    }
    // If the last received book is found, return the next book in the series
    if (indexOfLastReceivedBookInSeries !== -1) {
        const nextIndex = indexOfLastReceivedBookInSeries + 1;
        if (nextIndex < seriesProducts.length) {
            return {
                ...seriesProducts[nextIndex],
                numberInSeries: nextIndex + 1,
            };
        }
        return null;
    }
    // Return the selected initial book in the series if no previous book was received
    const initialSkuIndex = seriesProducts.findIndex(({ sku }) => campaignBooks.length > 0
        ? sku === campaignBooks[0]?.sku
        : sku === getContractInitialSku(contract));
    if (initialSkuIndex !== -1) {
        return {
            ...seriesProducts[initialSkuIndex],
            numberInSeries: initialSkuIndex + 1,
        };
    }
    return null;
};
